import { render, staticRenderFns } from "./UploadRebateListLander.vue?vue&type=template&id=812aa892"
import script from "./UploadRebateListLander.vue?vue&type=script&lang=js"
export * from "./UploadRebateListLander.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports